import { Iconify, DashboardCard, DocumentIcon, solidItem } from '@nexus/ari-lib';

import { Box, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export type DocumentItem = {
  id: number;
  label: string;
  icon: string;
  color: string;
};

type DashboardDocumentsSectionProps = {
  documents: DocumentItem[];
  onClick?: () => void;
  comingSoon?: boolean;
};

export function DashboardDocumentsSection({ documents, onClick, comingSoon = false }: DashboardDocumentsSectionProps) {
  const itemStyle = solidItem;
  return (
    <DashboardCard
      data-testid="cloud.dashboard.documents-section"
      title="Documents"
      subtitle="Knowledge Base"
      icon={<DocumentIcon sx={{ width: 28, height: 28 }} />}
      onClick={onClick}
      comingSoon={comingSoon}
    >
      {documents.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            gap: 1,
            color: 'text.secondary',
          }}
        >
          <DocumentIcon sx={{ width: 40, height: 40, opacity: 0.4 }} />
          <Typography variant="body2" sx={{ color: 'text.secondary', opacity: 0.4 }}>
            No documents uploaded yet
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: 1,
          }}
        >
          {documents.map((doc) => (
            <Box
              key={doc.id}
              sx={{
                width: 44,
                height: 52,
                ...itemStyle,
                borderRadius: 1.5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 44,
                  height: 52,
                  bgcolor: 'container.medium',
                  borderRadius: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Iconify icon={doc.icon} width={24} sx={{ color: doc.color }} />
              </Box>
              <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: '100%', fontSize: 10 }}>
                {doc.label}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </DashboardCard>
  );
}
